/**
 * Helpers para múltiplos anexos (boleto / nota fiscal) em contas financeiras.
 */

export interface AnexoConta {
  id: string;
  url: string;
  nome_arquivo: string;
  created_at?: string;
}

export interface ContaComAnexos {
  boleto_url?: string | null;
  boleto_nome_arquivo?: string | null;
  nota_fiscal_url?: string | null;
  nota_fiscal_nome_arquivo?: string | null;
  boletos?: AnexoConta[] | null;
  notas_fiscais?: AnexoConta[] | null;
}

function normalizeLista(
  lista: AnexoConta[] | null | undefined,
  urlLegacy?: string | null,
  nomeLegacy?: string | null
): AnexoConta[] {
  const fromJson = Array.isArray(lista) ? lista.filter((item) => item?.url) : [];
  if (fromJson.length > 0) {
    return fromJson.map((item) => ({
      id: String(item.id || item.url),
      url: String(item.url),
      nome_arquivo: String(item.nome_arquivo || 'arquivo'),
      created_at: item.created_at,
    }));
  }
  if (urlLegacy) {
    return [
      {
        id: String(urlLegacy),
        url: String(urlLegacy),
        nome_arquivo: String(nomeLegacy || 'arquivo'),
      },
    ];
  }
  return [];
}

export function getBoletosDaConta(conta: ContaComAnexos | null | undefined): AnexoConta[] {
  if (!conta) return [];
  return normalizeLista(conta.boletos, conta.boleto_url, conta.boleto_nome_arquivo);
}

export function getNotasFiscaisDaConta(conta: ContaComAnexos | null | undefined): AnexoConta[] {
  if (!conta) return [];
  return normalizeLista(conta.notas_fiscais, conta.nota_fiscal_url, conta.nota_fiscal_nome_arquivo);
}

export function contaTemBoleto(conta: ContaComAnexos | null | undefined): boolean {
  return getBoletosDaConta(conta).length > 0;
}

export function contaTemNotaFiscal(conta: ContaComAnexos | null | undefined): boolean {
  return getNotasFiscaisDaConta(conta).length > 0;
}
